<div class="phone-number-container">
  <div class="phone-number-flag">
    <img
      [src]="countryInfo?.image || 'default-flag.png'"
      [alt]="countryInfo?.name || 'Country flag'"
      class="flag-img">
  </div>
  <span class="phone-number-text">0{{ phoneNumber?.number }}</span>
</div>
